import { EMessageStatus, EContentType, IMessage } from '@/store/messageStore';
import { FC, ReactNode } from 'react';
import TextBubble from './TextBubble';
import ImgBubble from './ImgBubble';
import VideoBubble from './VideoBubble';
import { TipsWrap } from '@/assets/styles/common';

interface IBubbleProps {
  msgType: EContentType;
  status: EMessageStatus;
  messageItem: IMessage;
  msgBody?: string | ReactNode;
  isMe?: boolean;
  progress?: number;
  isPause?: boolean;
  onBubbleClick?: (status: EMessageStatus) => void;
}

const Bubble: FC<IBubbleProps> = ({
  msgType,
  isMe,
  status,
  msgBody,
  progress,
  onBubbleClick,
  messageItem,
  isPause,
}) => {
  if (msgType === EContentType.tips) {
    return <TipsWrap>{msgBody}</TipsWrap>;
  }

  if (msgType === EContentType.text || msgType === EContentType.SystemContentType) {
    return (
      <TextBubble
        onBubbleClick={(status) => {
          onBubbleClick?.(status);
        }}
        msgBody={msgBody as string}
        isMe={isMe}
        status={status}
        isRead={!!messageItem.isRead}
      />
    );
  }

  if (msgType === EContentType.image) {
    return (
      <ImgBubble
        progress={progress!}
        messageItem={messageItem}
        msgBody={msgBody as string}
        isMe={isMe}
        status={status}
        isRead={!!messageItem.isRead}
        isStopUpload={isPause}
      />
    );
  }

  if (msgType === EContentType.video) {
    return (
      <VideoBubble
        isStopUpload={isPause}
        messageItem={messageItem}
        progress={progress!}
        msgBody={msgBody as string}
        isMe={isMe}
        status={status}
        isRead={!!messageItem.isRead}
      />
    );
  }

  return <></>;
};

export default Bubble;
